// Konfiguracja tabeli "Transakcje" na karcie klienta (Panel Handlowca).
// Endpoint: GET /api/ui/sales-crm/deals?clientId={clientId}

import { IWiseTableColumn, IWiseTableParameter, IWiseTableAction } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

export const getTraderClientCardDealsTableParameters = (): IWiseTableParameter[] => {
  return [];
};

/**
 * Kolumny tabeli: nazwa transakcji, etap, wartosc, data utworzenia.
 */
export const getTraderClientCardDealsTableColumns = (
  t: (key: string) => string
): IWiseTableColumn[] => {
  return [
    {
      type: 'text',
      label: t('Nazwa'),
      field_symbol: 'name',
      align: 'left',
      tooltip: null,
      size: 200
    },
    {
      type: 'text',
      label: t('Etap'),
      field_symbol: 'stage',
      align: 'center',
      tooltip: null,
      size: 160
    },
    {
      type: 'text',
      label: t('Wartość'),
      field_symbol: 'value',
      align: 'right',
      tooltip: null,
      size: 130
    },
    {
      type: 'date',
      label: t('Data utworzenia'),
      field_symbol: 'createdAt',
      align: 'center',
      tooltip: null,
      size: 130
    }
  ];
};

export const getTraderClientCardDealsTableActions = (): IWiseTableAction[] => {
  return [];
};

/**
 * Parametry do pobierania danych - endpoint /sales-crm/deals z filtrem clientId.
 */
export const traderClientCardDealsTableLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/deals',
  params_list: 'clientId=:clientId'
};
